import moment from 'moment';
import { getElapsedTime } from '../../../../../utils';
import { GW_SERVICES_PREFIXES } from '../../../../../constants';

import inboundAnswer from '../assets/inbound_answer.svg';
import inboundNoAnswer from '../assets/inbound_no_answer.svg';
import outboundAnswer from '../assets/outbound_answer.svg';
import outboundNoAnswer from '../assets/outbound_no_answer.svg';
import inwardAnswer from '../assets/inward_answer.svg';
import inwardNoAnswer from '../assets/inward_no_answer.svg';
import callbackAnswer from '../assets/callback_answer.svg';
import callbackNoAnswer from '../assets/callback_no_answer.svg';

const { C300 } = GW_SERVICES_PREFIXES;

export const computeTypeIcon = (type: string) => {
  switch (type) {
    case 'REGULAR_INBOUND_ANSWER':
      return inboundAnswer;
    case 'REGULAR_INBOUND_NO_ANSWER':
      return inboundNoAnswer;
    case 'REGULAR_OUTBOUND_ANSWER':
      return outboundAnswer;
    case 'REGULAR_OUTBOUND_NO_ANSWER':
      return outboundNoAnswer;
    case 'REGULAR_INWARD_ANSWER':
      return inwardAnswer;
    case 'REGULAR_INWARD_NO_ANSWER':
      return inwardNoAnswer;
    case 'CALLBACK_OUTBOUND_ANSWER':
    case 'CALLBACK_INWARD_ANSWER':
    case 'CALLBACK_INBOUND_ANSWER':
      return callbackAnswer;
    case 'CALLBACK_OUTBOUND_NO_ANSWER':
    case 'CALLBACK_INWARD_NO_ANSWER':
    case 'CALLBACK_INBOUND_NO_ANSWER':
      return callbackNoAnswer;
    default:
      return inboundAnswer;
  }
};

export const reverseAddress = (value: string | null) => {
  if (!value) {
    return;
  }

  const splitArray = value.split(',');

  const trimmedArray = splitArray.map((str: string) => {
    return str.trim();
  });

  return trimmedArray.reverse().join(', ');
};

export const formatTimeAndCheckHours = (
  calldate: string
): { moreThanHour: boolean; time: string } => {
  let moreThanHour = true;

  const elapsedTime = getElapsedTime(calldate, Date.now());
  const trimmedTime = elapsedTime.trim();

  const array = trimmedTime.split(' ');

  if (array.length === 1) {
    moreThanHour = !!moment(array[array.length - 1], 'HH:mm:ss').hours();

    array[array.length - 1] = `(${array[array.length - 1]})`;
  }

  return { time: array.join(' '), moreThanHour };
};

export const formatBillsecToSeconds = (value: string): number => {
  const temp = value.split(':');

  return Number(temp[0]) * 60 + Number(temp[1]);
};

export const getFirstLetters = (value: string): string => {
  const namesArray = value.toUpperCase().split(' ');

  return `${namesArray[0].charAt(0)}${namesArray[1].charAt(0)}`;
};

/* Валидирует пошаговый ввод длительности разговора в формате mm:ss.
   Нужна для поля фильтра, чтобы не пропускать невалидные символы/позиции
   и при ошибке оставлять предыдущее корректное значение. */
export const validateBillsecFormat = (
  newValue: string,
  currentValue: string
): string => {
  if (newValue.length < currentValue.length) {
    return newValue;
  }

  // Жесточайший костыль, сделать через одну регулярку пока не получается
  if (newValue.length === 1 && /^[0-5]$/g.test(newValue)) {
    return newValue;
  }

  if (newValue.length === 2 && /^[0-5]\d$/.test(newValue)) {
    return newValue;
  }

  if (newValue.length === 3 && /^[0-5]\d:$/.test(newValue)) {
    return newValue;
  }

  if (newValue.length === 4 && /^[0-5]\d:[0-5]$/.test(newValue)) {
    return newValue;
  }

  if (newValue.length === 5 && /^[0-5]\d:[0-5]\d$/.test(newValue)) {
    return newValue;
  }

  return currentValue;
};

export const openExcelReport = (id: string) => {
  window.open(`/${C300}/call_log/get_report/${id}`);
};
